<template>
  <div>
    <div class="air__utils__heading">
      <h5>Reservering #{{ reserveringsnummer ? reserveringsnummer : $route.params.reservation_id }}</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card" :class="reservationCancelled ? 'bg-cancelled' : ''">
          <div class="card-body">
            <single-reservation :updateReserveringsNummer="nummer=>{updateReserveringsNummer(nummer)}" :changeReservationStatusStyle="(bool)=>{this.changeReservationStatusStyle(bool)}" :reservationId="$route.params.reservation_id" />
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import SingleReservation from '@/components/widgets/Reservations/SingleReservation'
// import moment from 'moment'
export default {
  components: {
    SingleReservation,
  },
  data() {
    return {
      reservationCancelled: false,
      reserveringsnummer: undefined,
    }
  },
  methods: {
    changeReservationStatusStyle(bool) {
      this.reservationCancelled = bool
    },
    updateReserveringsNummer(nummer) {
      this.reserveringsnummer = nummer
    },
  },
}
</script>
<style lang="scss">
  .bg-cancelled{
    background-color: lighten(#c0392b, 20%);
  }
</style>
